import { render, staticRenderFns } from "./RatingProfileUpdate.vue?vue&type=template&id=9f3e8aa6&scoped=true"
import script from "./RatingProfileUpdate.vue?vue&type=script&lang=js"
export * from "./RatingProfileUpdate.vue?vue&type=script&lang=js"
import style0 from "./RatingProfileUpdate.vue?vue&type=style&index=0&id=9f3e8aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3e8aa6",
  null
  
)

export default component.exports